import ObjectModel from "~/models/objectModel";
import Permittee from "~/models/permittee";
import {Hash} from "~/interfaces/hashInterfaces";
import ObjectModelPermission from "~/models/objectModelPermissions/objectModelPermission";
import IRepo from "~/interfaces/repo";
import Repo from "~/state/modules/repo";

export default class ObjectModelPermissionPermittee extends Permittee<ObjectModel> {
  sort_order: number;

  static repo: IRepo<ObjectModelPermissionPermittee> = new Repo<ObjectModelPermissionPermittee>('objectModelPermissionPermittees', ObjectModelPermissionPermittee);

  constructor(parent: ObjectModel, json: Hash = {}) {
    super(parent, json, ObjectModelPermissionPermittee.rootName);
  }

  static get rootName(): string {
    return 'permission_permittees';
  }

  get objectModel(): ObjectModel {
    return this.parent;
  }

  get permissionsArray(): ObjectModelPermission[] {
    return this.objectModel.permissionsArray.filter(permission => permission.permittee_client_id === this.client_id);
  }

  afterDestroy() {
    super.afterDestroy();
    this.permissionsArray.forEach(permission => permission.destroy());
    this.objectModel.updateSortOrder(this.rootName);
  }

  get isFirst(): boolean {
    return this.sort_order <= 0;
  }

  get isLast(): boolean {
    return this.sort_order === this.parent.nextSortOrderFor(this.rootName) - 1;
  }

  moveLeft(): void {
    if (!this.isFirst) {
      this.sort_order--;
      this.objectModel.updatePermissionPermitteePositions(this, this.sort_order);
    }
  }

  moveRight(): void {
    if (!this.isLast) {
      this.sort_order++;
      this.objectModel.updatePermissionPermitteePositions(this, this.sort_order);
    }
  }
}